import { Card, Tag, Text, Title } from '@bancobarigui/barihaus';

interface StatusCardProps {
  status: number | undefined;
  statusDescription: string;
}

export function StatusCard({ status, statusDescription }: StatusCardProps) {
  const getStatusColor = (status: number | undefined) => {
    if (status === undefined) return 'default';
    switch (status) {
      case 0: return 'orange';
      case 1: return 'blue';
      case 2: return 'green';
      case 3: return 'red';
      default: return 'default';
    }
  };

  return (
    <Card className="shadow-sm">
      <div className="flex items-center justify-between mb-4">
        <Title level={4}>Status Atual</Title>
        <Tag color={getStatusColor(status)} showBorder className="text-base px-4 py-1">
          {statusDescription}
        </Tag>
      </div>
      <Text className="text-gray-600">Status atual do item da inspeção</Text>
    </Card>
  );
}
